<app-layout-crud-index
  [titulo]="title"
  [length]="length"
  [dataSource]="dataSource"
  [filterFields]="filterFields"
  [configColumns]="configColumns"
  [displayedColumns]="displayedColumns"
  (onChangePage)="changePage($event)"
  (onFilter)="filter($event)"
  (onSubmitAdvancedFilter)="submitAdvancedFilter($event)"
  (onOpenShow)="openShow($event)"
  (onOpenNew)="openNew($event)"
  (onOpenEdit)="openEdit($event)"
  (onOpenDelete)="openDelete($event)"
  (onResetFilter)="resetFilter()"
  >

  <!-- <table-responsive
    table
    [length]="length"
    (changePage)="changePage($event)"
    (filter)="filter($event)"
    [displayedColumns]="displayedColumns"
    [dataSource]="dataSource"
    [configColumns]="configColumns"
    (openShow)="openShow($event)"
    (openNew)="openNew($event)"
    (openEdit)="openEdit($event)"
    (openDelete)="openDelete($event)"
    [showLock]="true"
    [lockProperty]="'isActive'"
    (onSelectionChange)="onSelectionChange($event)"
    [showInfo]="true"
    [infoProperty]="'hasAudit'"
    [currentTab]="currentTab"
    [userType]="userType"
    [isEditableShow]="permissionService.is(permissionService.systemActionRoles.EVENT_EDIT_BUTTON_SHOW)"
    [isEditableEnabled]="permissionService.is(permissionService.systemActionRoles.EVENT_EDIT_BUTTON_ENABLED)"

    [isDeletableShow]="permissionService.is(permissionService.systemActionRoles.EVENT_DELETE_BUTTON_SHOW)"
    [isDeletableEnabled]="permissionService.is(permissionService.systemActionRoles.EVENT_DELETE_BUTTON_ENABLED)"
  ></table-responsive> -->
  
  <app-events-table
    table
    [length]="length"
    (changePage)="changePage($event)"
    (filter)="filter($event)"
    [displayedColumns]="displayedColumns"
    [dataSource]="dataSource"
    [configColumns]="configColumns"
    (openShow)="openShow($event)"
    (openShowMeeting)="openShowMeeting($event)"
    (openNew)="openNew($event)"
    (openQrcode)="openQrCode($event)"
    (openEdit)="openEdit($event)"
    (openDelete)="openDelete($event)"
    [showLock]="true"
    [lockProperty]="'isLock'"
    [showActive]="true"
    [activeProperty]="'isActive'"
    [showKey]="true"
    (onSelectionChange)="onSelectionChange($event)">
  </app-events-table>
</app-layout-crud-index>
